export default __webpack_public_path__ + "static/media/factory.3d5b477d.svg";